import { httpClient } from '../http/httpClient'
import {
  SupportRequest,
  SupportRequestReason,
} from '@/app/entities/SupportRequest'
import { PartnerType } from '@/app/utils/partners.enum'

export interface CreateSupportRequestParams {
  reason: SupportRequestReason
  description?: string
  product?: PartnerType
  proposal?: string
  transactionId?: string
  metadata?: Record<string, unknown>
  screen?: string
}

export async function createSupportRequest({
  screen,
  ...body
}: CreateSupportRequestParams) {
  const { data } = await httpClient.post<SupportRequest>(
    '/support-requests',
    body,
    screen ? { headers: { 'X-Screen': screen } } : undefined,
  )

  return data
}
